declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}

const hasConsent = () => {
  if (typeof window === "undefined") return false;
  return localStorage.getItem("pixelConsent") === "accepted";
};

let isLoaded = false;

export const loadMetaPixel = (pixelId: string) => {
  if (!hasConsent()) return;

  if (typeof window === "undefined") return;

  if (isLoaded || window.fbq) return;

  const fbq: any = function (...args: any[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
    } else {
      fbq.queue.push(args);
    }
  };

  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = "2.0";

  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";

  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode?.insertBefore(script, firstScript);

  window.fbq?.("init", pixelId);

  isLoaded = true;
};

export const trackPageView = () => {
  if (!hasConsent()) return;

  const tryTrack = (retries = 5) => {
    if (window.fbq) {
      window.fbq("track", "PageView");
    } else if (retries > 0) {
      setTimeout(() => tryTrack(retries - 1), 200);
    }
  };

  tryTrack();
};

export const trackEvent = (name: string, params?: object) => {
  if (!hasConsent()) return;
  window.fbq?.("track", name, params);
};

export const trackCustomEvent = (name: string, params?: object) => {
  if (!hasConsent()) return;
  window.fbq?.("trackCustom", name, params);
};